import { useState } from 'react';
import { FaRegPaperPlane } from 'react-icons/fa';
import { toast } from 'react-toastify';
import admissionImage from '../../../Images/Admission.jpg';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import './Admission.css';

const Admission = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    nid: '',
    email: '',
    phone: '',
    parent_phone: '',
    passport: '',
    course: '',
    date: '',
    details: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        'https://msolaimantechnical.com/master/api/v1/enroll/store',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: formData.first_name,
            last_name: formData.last_name,
            nid: formData.nid,
            email: formData.email,
            phone: formData.phone,
            parent_phone: formData.parent_phone,
            passport: formData.passport,
            course: formData.course,
            date: formData.date,
            details: formData.details,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success('Enrollment submitted successfully', {
          autoClose: 2000,
        });

        // optional reset
        setFormData({
          first_name: '',
          last_name: '',
          nid: '',
          email: '',
          phone: '',
          parent_phone: '',
          passport: '',
          course: '',
          date: '',
          details: '',
        });
      } else {
        toast.error('Something went wrong', {
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Server Error', {
        autoClose: 3000,
      });
    }
  };

  return (
    <div>
      <Breadcrumb
        title='Join M.Solaiman TTC'
        subTitle='Application From'
        slgs='/admission'
        img={admissionImage}
      ></Breadcrumb>
      <section className='pb-[60px] pt-[60px]'>
        <div className='container p-6 mx-auto'>
          <div className='grid grid-cols-1 lg:grid-cols-12'>
            <div className='lg:col-span-8 lg:col-start-3'>
              <div className='admission-card'>
                <div>
                  <h4 className='capitalize text-center text-[18px] sm:text-[20px] md:text-[23px] lg:text-[26px] xl:text-[30px] font-semibold leading-tight mb-5'>
                    Admission application form
                  </h4>
                </div>
                <form
                  onSubmit={handleSubmit}
                  className='container flex flex-col mx-auto space-y-12'
                >
                  <fieldset className='grid grid-cols-6 gap-6'>
                    <div className='grid grid-cols-6 gap-4 col-span-full'>
                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='firstName'>
                          First Name
                        </label>
                        <input
                          id='firstName'
                          type='text'
                          name='first_name'
                          value={formData.first_name}
                          onChange={handleChange}
                          placeholder='First Name'
                          className='w-full p-3 rounded-md bg-white text-black input-from-contorl-2'
                          required
                        />
                      </div>

                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='LastName'>
                          Last Name
                        </label>
                        <input
                          id='LastName'
                          type='text'
                          name='last_name'
                          value={formData.last_name}
                          onChange={handleChange}
                          placeholder='Last Name'
                          className='w-full p-3 rounded-md text-gray-900 input-from-contorl-2'
                          required
                        />
                      </div>

                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='Email'>
                          Your Email
                        </label>
                        <input
                          id='Email'
                          type='email'
                          name='email'
                          value={formData.email}
                          onChange={handleChange}
                          placeholder='Your Email'
                          className='w-full p-3 rounded-md text-gray-900 input-from-contorl-2'
                          required
                        />
                      </div>

                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='phoneNumber'>
                          Phone Number
                        </label>
                        <input
                          id='phoneNumber'
                          type='text'
                          name='phone'
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder='Your Number'
                          className='w-full p-3 rounded-md text-gray-900 input-from-contorl-2'
                          required
                        />
                      </div>

                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='Passport'>
                          Passport Number
                        </label>
                        <input
                          id='Passport'
                          type='text'
                          name='passport'
                          value={formData.passport}
                          onChange={handleChange}
                          placeholder='Your Passport Number'
                          className='w-full p-3 text-base rounded-md text-gray-900 input-from-contorl-2'
                          required
                        />
                      </div>

                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='NID'>
                          NID Card Number
                        </label>
                        <input
                          id='NID'
                          type='text'
                          name='nid'
                          value={formData.nid}
                          onChange={handleChange}
                          placeholder='NID Card Number'
                          className='w-full p-3 text-base rounded-md text-gray-900 input-from-contorl-2'
                          required
                        />
                      </div>

                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='Parent'>
                          Parent Mobile Number
                        </label>
                        <input
                          id='Parent'
                          type='text'
                          name='parent_phone'
                          value={formData.parent_phone}
                          onChange={handleChange}
                          placeholder='Parent Mobile Number'
                          className='w-full p-3 text-base rounded-md text-gray-900 input-from-contorl-2'
                          required
                        />
                      </div>

                      <div className='col-span-full sm:col-span-3'>
                        <label className='lebel-title' for='date'>
                          Date
                        </label>
                        <input
                          id='date'
                          type='date'
                          name='date'
                          value={formData.date}
                          onChange={handleChange}
                          className='w-full p-3 text-base rounded-md text-gray-900 input-from-contorl-2'
                          required
                        />
                      </div>
                      <div className='col-span-full'>
                        <label className='lebel-title' for='Courses'>
                          Courses
                        </label>
                        <select
                          id='Courses'
                          name='course'
                          value={formData.course}
                          onChange={handleChange}
                          className='w-full p-3 text-base rounded-md text-gray-900 input-from-contorl-2'
                          required
                        >
                          <option value='Welding-1G-to-4G'>
                            Welding 1G to 4G
                          </option>
                          <option value='Welding-4G-to-6G-TIG'>
                            Welding 4G to 6G + TIG
                          </option>
                          <option value='1G-to-TIG-Complete'>
                            1G to TIG Complete
                          </option>
                          <option value='1G-to-6G-MIG'>1G to 6G + MIG</option>
                          <option value='Pipe-Fitter-Plumber'>
                            Pipe Fitter, Plumber
                          </option>
                          <option value='Shuttering-Carpenter'>
                            Shuttering Carpenter
                          </option>
                        </select>
                      </div>

                      <div className='col-span-full'>
                        <label className='lebel-title' for='Message'>
                          Your Message
                        </label>
                        <textarea
                          id='Message'
                          rows='5'
                          name='details'
                          value={formData.details}
                          onChange={handleChange}
                          placeholder='Write Your Message'
                          className='w-full p-3 rounded-md text-gray-900 input-from-contorl-2'
                          required
                        ></textarea>
                      </div>

                      <div className='col-span-full text-center'>
                        <button type='submit' className='primary-btn'>
                          Submit application form
                          <FaRegPaperPlane className='ml-2' />
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Admission;
